import { SelectField } from '~/common/components';
import { SelectErrorIndicator, SelectLoadingIndicator } from '@wyz/ui';
import * as React from 'react';
import { Trans, useLocale } from '~/common/context';
import { useManageCountries } from '~/connect/api';
import { ICountry } from '~/connect/types';
import { LocaleUtils } from '@wyz/utils';
type SelectCountriesProps = {
  name: string;
  label: React.ReactNode;
  required?: boolean;
  readOnly?: boolean;
  valuePath?: keyof ICountry;
};
export const SelectCountries = ({
  name,
  label,
  required = false,
  readOnly,
  valuePath = 'localId',
}: SelectCountriesProps) => {
  const locale = useLocale();
  const manageCountries = useManageCountries({
    listActive: { enabled: true },
  });
  return (
    <>
      {manageCountries.listActive.isError && (
        <SelectErrorIndicator
          label={label}
          message={<Trans i18nKey='app.common.select_field.options_error' />}
        />
      )}
      {!manageCountries.listActive.isSettled && (
        <SelectLoadingIndicator label={label} />
      )}
      {manageCountries.listActive.isSuccess && (
        <SelectField
          name={name}
          label={label}
          options={manageCountries.listActive.data.data.map((country) => ({
            label:
              LocaleUtils.getHumanReadableLabel({
                userLocale: locale.locale,
                locale: country.isoCode,
                fallback: country.name,
                options: { type: 'region' },
              }) ?? country.name,
            value: country[valuePath] as string, // we are only fetching active countries => localId should always exist
          }))}
          isClearable
          required={required}
          isDisabled={readOnly}
        />
      )}
    </>
  );
};
